import React, { useCallback, useRef } from 'react'

import './iframe.sass'

export const MatterportIframe = ({ setSDK, model }: { setSDK: (skd: any) => void, model: string }) => {
    const iframe = useRef<HTMLIFrameElement | null>(null)
    const setRef = useCallback(node => {
        if (node) {
            iframe.current = node
            iframe.current?.addEventListener('load', sdkConnect(iframe.current, setSDK), true);
        }
    }, [setSDK])

    const sdkConnect = (iframe: HTMLIFrameElement, handleSDK: (skd: any) => void) => async () => {
        try {
            var key = process.env.REACT_APP_MATTERPORT_KEY
            var version = process.env.REACT_APP_MATTERPORT_SDK_VERSION
            const sdk = await iframe.contentWindow?.MP_SDK.connect(iframe, key, version);
            handleSDK(sdk)
        } catch (error) {
            alert(error)
        }
    }

    return (
        <div className="sdk-component">
            <iframe title="otavio" ref={setRef} id="showcase" width="100%" height="100%" src={`/matterport/index.html?m=${model}&title=0&play=1&qs=1&log=0&applicationKey=${process.env.REACT_APP_MATTERPORT_KEY}`} frameBorder="0"></iframe>
        </div>
    )
}